import { LOCALES } from '../../../../../constants/locales';
import { LABELS } from '../../../../../constants/subtitle-labels';

import de from './Ebook_Writing_de-DE.vtt';
import es from './Ebook_Writing_es.vtt';
import fr from './Ebook_Writing_fr-FR.vtt';
import it from './Ebook_Writing_it-IT.vtt';
import nl from './Ebook_Writing_nl-NL.vtt';
import pt from './Ebook_Writing_pt-BR.vtt';
import en from './Ebook_Writing_en-US.vtt';

export default [{
    src: de,
    label: LABELS[LOCALES.DE],
    srcLang: LOCALES.DE
}, {
    src: es,
    label: LABELS[LOCALES.ES],
    srcLang: LOCALES.ES
}, {
    src: fr,
    label: LABELS[LOCALES.FR],
    srcLang: LOCALES.FR
}, {
    src: it,
    label: LABELS[LOCALES.IT],
    srcLang: LOCALES.IT
}, {
    src: nl,
    label: LABELS[LOCALES.NL],
    srcLang: LOCALES.NL
}, {
    src: pt,
    label: LABELS[LOCALES.PT],
    srcLang: LOCALES.PT
}, {
    src: en,
    label: LABELS[LOCALES.EN],
    srcLang: LOCALES.EN
}];
